var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1458_11581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1458_11581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.8009L15.9002 14.7009C16.0835 14.8842 16.3169 14.9759 16.6002 14.9759C16.8835 14.9759 17.1169 14.8842 17.3002 14.7009C17.4835 14.5175 17.5752 14.2842 17.5752 14.0009C17.5752 13.7175 17.4835 13.4842 17.3002 13.3009L12.7002 8.70088C12.5002 8.50088 12.2669 8.40088 12.0002 8.40088C11.7335 8.40088 11.5002 8.50088 11.3002 8.70088L6.7002 13.3009C6.51686 13.4842 6.4252 13.7175 6.4252 14.0009C6.4252 14.2842 6.51686 14.5175 6.7002 14.7009C6.88353 14.8842 7.11686 14.9759 7.4002 14.9759C7.68353 14.9759 7.91686 14.8842 8.1002 14.7009L12.0002 10.8009Z",
    fill: "#FD4C0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.dc7e3254207ae22dcf8e7dcf83f08ecb.svg";
export { ForwardRef as ReactComponent };